<template>
  <div class="property-alert-edit">
    <h1 class="center-text">Edit Property Alert</h1>
    <form @submit.prevent="editAlert">
      <div v-if="apiError" class="error center-element">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div v-if="isError" class="error center-element">
        Error with form<br />
      </div>
      <div class="form-300 center-element">
        <label>Recipient Name</label><br />
        <input
          v-model.trim="alert.name"
          type="text"
          placeholder="Recipient Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property Name'"
          required
        /><br />
        <label>Email</label><br />
        <input
          v-model.trim="alert.email"
          type="text"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <div v-if="isEmailError" class="error">
          {{ errorEmailMessage }}<br />
        </div>
        <label>SMS/Text Number (Optional)</label><br />
        <input
          v-model.trim="alert.sms_number"
          type="text"
          placeholder="Mobile Number"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Mobile Number'"
        /><br />
        <button type="submit" class="button button-300">Edit Alert</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isError: false,
      isEmailError: false,
      errorEmailMessage: "",
      alert: []
    };
  },
  computed: {
    // alert () {
    //   return this.$store.getters.alert;
    // },
    apiError() {
      return this.$store.getters.apiError;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    }
  },
  created() {
    // this.$store.dispatch('getPropertyAlert', {
    //   propertyID: this.$route.params.property_id,
    //   alertID: this.$route.params.id
    // });
    // this.$store.dispatch('resetAllAPIErrorAndMessages');
    this.isPasswordError = false;
    this.errorPasswordMessage = "";
    this.isError = false;
  },
  methods: {
    editAlert: function() {
      this.isError = false;
      this.isEmailError = false;
      let reEmailFormat = /^[^@|^\s]+@\S+\.\S+/;
      let resultEmailFormat = reEmailFormat.test(this.alert.email);
      if (!resultEmailFormat) {
        this.isError = true;
        this.isEmailError = true;
        this.errorEmailMessage = "Invalid email entered";
      }
      if (!this.isError) {
        // this.$store.dispatch('editPropertyAlert', {
        //   propertyID: this.$route.params.property_id,
        //   payload: this.alert
        // });
      }
    }
  }
};
</script>
